module.exports = __webpack_public_path__ + "static/media/EmployeeManage.e980ab13.svg";